import { ArrowUpIcon } from "@phosphor-icons/react/dist/csr/ArrowUp";
import { useState } from "react";
import { Button } from "@volca/ui/components/ui/button";
import { LogoIcon } from "@volca/ui/components/ui/logo";
import { Stack } from "@volca/ui/components/ui/stack";
import { cn } from "@volca/ui/lib/utils";

/** A question starts here and continues in the page's chat. */
export const AskVolca = ({
  placeholder,
  onAsk,
  className,
  hidden = false,
}: {
  placeholder: string;
  onAsk: (question: string) => void;
  className?: string;
  hidden?: boolean;
}) => {
  const [text, setText] = useState("");
  const send = () => {
    const question = text.trim();
    if (!question) return;
    onAsk(question);
    setText("");
  };
  return (
    <Stack
      className={cn(
        "pointer-events-none sticky bottom-4 z-10 mt-auto grid pt-10",
        { hidden },
        className,
      )}
    >
      <Stack
        render={<form />}
        direction="row"
        gap={2}
        align="center"
        className="pointer-events-auto col-start-1 w-full max-w-xl min-w-0 justify-self-center rounded-full border border-line bg-surface-raised py-1.5 ps-3 pe-1.5 shadow-lg transition-shadow duration-150 focus-within:border-focus focus-within:shadow-xl focus-within:ring-3 focus-within:ring-focus/50"
        onSubmit={(event) => {
          event.preventDefault();
          send();
        }}
      >
        <LogoIcon width={18} height={15} className="flex-none" />
        <input
          value={text}
          onChange={(event) => setText(event.target.value)}
          placeholder={placeholder}
          aria-label="Ask Volca"
          className="min-h-10 min-w-0 flex-1 bg-transparent text-base text-ink outline-none placeholder:text-subtle sm:text-sm pointer-coarse:min-h-11 pointer-coarse:text-base"
        />
        <Button
          type="submit"
          size="icon-sm"
          color="neutral"
          aria-label="Ask"
          disabled={!text.trim()}
          className="size-10 rounded-full pointer-coarse:size-11"
        >
          <ArrowUpIcon aria-hidden />
        </Button>
      </Stack>
    </Stack>
  );
};
